import React from 'react';

import './style.css';

const IconVimeo = () => {
    return (
        <div className="IconVimeo">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.847 20.847">
                <path d="M17.811 2.018c2.017.053 3.026 1.198 3.036 3.438 0 .147-.005.3-.013.457-.089 1.899-1.502 4.486-4.245 7.76-2.829 3.43-5.229 5.147-7.2 5.156-1.226 0-2.244-1.05-3.061-3.151l-.858-2.88-.848-2.876c-.625-2.084-1.293-3.124-2.006-3.124-.156 0-.697.304-1.626.91L0 6.537l1.536-1.276 1.511-1.263C4.4 2.914 5.429 2.328 6.135 2.241c.094-.01.188-.013.284-.013 1.449 0 2.354 1.041 2.709 3.124.198 1.188.362 2.154.495 2.896.129.744.237 1.262.323 1.557.479 1.97.995 2.96 1.55 2.968.426 0 1.082-.642 1.968-1.926.866-1.319 1.332-2.296 1.392-2.932.019-.129.026-.25.026-.362 0-.861-.474-1.29-1.418-1.29-.479 0-.99.102-1.537.299.98-3.021 2.864-4.534 5.65-4.544h.234z" />
            </svg>
        </div>
    );
};

export default IconVimeo;



// WEBPACK FOOTER //
// ./src/components/atoms/iconVimeo/index.js